import React from 'react';
import jpl from '../../assets/static/juzgado/jplcovid19.jpg';

const JuzgadoCuerpo = () => (
  <div>
    <img src={jpl} alt='' width='100%' />
  </div>
);
export default JuzgadoCuerpo;
